import { call, put, takeLatest } from 'redux-saga/effects';

import { getCurrencyList } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

export function* getData(action) {
  const response = yield call(getCurrencyList, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* currencyListSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
